<template>
  <div class="page-team">
    <crm-panel :title="'数据字典'">
      <div class="page-buttons">
        <crm-button
          v-if="auth.dictionaryAdd && auth.dictionaryAdd.toggleStatus"
          :buttonType="'secondary'"
          :text="'新增'"
          @click="isAddDialogVisible = true"
        >
        </crm-button>
      </div>
      <div class="mt20">
        <el-form ref="form" :inline="true">
          <el-form-item label="">
            <el-input
              class="search-input"
              placeholder="字典名称"
              v-model="dictionaryName"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        :data="dictionaryList.results"
        border
        v-loading="loading"
        height="100%"
        style="width: 100%"
      >
        <el-table-column label="字典名称" align="center" prop="name">
        </el-table-column>
        <el-table-column prop="remark" align="center" label="备注">
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button @click="handleGoDetail(scope)" type="text" size="small"
              >查看字典项</el-button
            >
            <el-button
              @click="handleOpenModify(scope)"
              type="text"
              size="small"
              v-if="auth.dictionaryUpdate && auth.dictionaryUpdate.toggleStatus"
              >修改</el-button
            >
            <el-button
              @click="handleDelete(scope)"
              type="text"
              size="small"
              v-if="auth.dictionaryDelete && auth.dictionaryDelete.toggleStatus"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :current-page="dictionaryList.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="dictionaryList.pageSize"
          layout="sizes, prev, pager, next"
          :total="dictionaryList.totalCount"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <!-- 查看字典项侧面板 -->
    <div v-if="dictionaryDetailVisible">
      <dictionary-detail
        :dictionaryDetailKey="dictionaryDetailKey"
        @handleCloseDetail="dictionaryDetailVisible = false"
      >
      </dictionary-detail>
    </div>

    <!-- 新增字典 -->
    <add-edit-dialog v-if="isAddDialogVisible">
      <crm-panel title="新增字典">
        <div class="page-buttons">
          <crm-button :text="'保存'" @click="handleAddDictionary()">
          </crm-button>
          <crm-button
            :buttonType="'plain'"
            :text="'取消'"
            @click="cancelAddDictionary()"
          >
          </crm-button>
        </div>
        <el-form label-width="100px" class="clearfix add-edit-form">
          <el-col :span="12" :offset="5">
            <el-form-item label="字典名称" :rules="{ required: true }">
              <el-input v-model="addForm.name" :maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="5">
            <el-form-item label="字典code" :rules="{ required: true }">
              <el-input v-model="addForm.code"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="5">
            <el-form-item label="备注">
              <el-input
                v-model="addForm.remark"
                type="textarea"
                :rows="4"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </crm-panel>
    </add-edit-dialog>

    <!-- 编辑字典弹窗 -->
    <add-edit-dialog v-if="isUpdateDialogVisible">
      <crm-panel title="编辑字典">
        <div class="page-buttons">
          <crm-button :text="'保存'" @click="handleUpdateDictionary()">
          </crm-button>
          <crm-button
            :buttonType="'plain'"
            :text="'取消'"
            @click="isUpdateDialogVisible = false"
          >
          </crm-button>
        </div>
        <el-form label-width="100px" class="clearfix add-edit-form">
          <el-col :span="12" :offset="5">
            <el-form-item label="字典名称" :rules="{ required: true }">
              <el-input v-model="updateForm.name" :maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="5">
            <el-form-item label="字典code" :rules="{ required: true }">
              <el-input v-model="updateForm.code"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="5">
            <el-form-item label="备注">
              <el-input
                v-model="updateForm.remark"
                type="textarea"
                :rows="4"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </crm-panel>
    </add-edit-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DictionaryDetail from '~component/business/backstage/DictionaryDetail.vue';
import crmPanel from '@/components/base/crmPanel';
import crmButton from '@/components/base/crmButton';
import AddEditDialog from '@/components/base/addEditDialog';

export default {
  components: {
    DictionaryDetail,
    crmPanel,
    crmButton,
    AddEditDialog,
  },
  data() {
    return {
      loading: false,
      isAddDialogVisible: false,
      isUpdateDialogVisible: false,
      dictionaryName: '',
      addForm: {
        name: '',
        code: '',
        remark: '',
      },
      updateForm: {
        scope: {},
        name: '',
        code: '',
        remark: '',
      },
      page: {
        pageSize: 10,
        pageNumber: 1,
      },
      // 查看字典项
      dictionaryDetailVisible: false,
      dictionaryDetailKey: {},
    };
  },
  computed: {
    ...mapGetters({
      backstageMenu: 'authority/backstageMenu',
      auth: 'authority/auth',
      dictionaryList: 'backstage/dictionaryList',
    }),
  },
  created() {
    this.getDictionaryList(this.page);
  },
  methods: {
    ...mapActions({
      getDictionaryList: 'backstage/getDictionaryList',
      deleteDictionary: 'backstage/deleteDictionary',
      addDictionary: 'backstage/addDictionary',
      updateDictionary: 'backstage/updateDictionary',
    }),
    handleSearch() {
      this.page.pageNumber = 1;
      this.getDictionaryList({
        ...this.page,
        name: this.dictionaryName,
      });
    },
    cancelAddDictionary() {
      this.isAddDialogVisible = false;
      this.addForm = {
        name: '',
        code: '',
        remark: '',
      };
    },
    handleAddDictionary() {
      this.addDictionary(this.addForm).then(() => {
        this.isAddDialogVisible = false;
        this.getDictionaryList(this.page);
        this.addForm = {
          name: '',
          code: '',
          remark: '',
        };
      });
    },
    handleGoDetail(scope) {
      this.dictionaryDetailVisible = true;
      this.dictionaryDetailKey = scope.row;
    },
    handleOpenModify(scope) {
      this.updateForm = {
        scope,
        name: scope.row.name,
        code: scope.row.code,
        remark: scope.row.remark,
      };
      this.isUpdateDialogVisible = true;
    },
    handleUpdateDictionary() {
      this.updateDictionary({
        name: this.updateForm.name,
        code: this.updateForm.code,
        remark: this.updateForm.remark,
        uid: this.updateForm.scope.row.uid,
      }).then(() => {
        this.$message({
          type: 'success',
          message: '修改成功',
        });
        this.isUpdateDialogVisible = false;
        this.getDictionaryList(this.page);
      });
    },
    handleDelete(scope) {
      this.$confirm(`确定删除${scope.row.name}？`).then(() => {
        this.deleteDictionary({
          uid: scope.row.uid,
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功',
          });
          this.getDictionaryList(this.page);
        });
      });
    },
    handleSizeChange(size) {
      this.page.pageSize = size;
      this.page.pageNumber = 1;
      this.getDictionaryList(this.page);
    },
    handlePageChange(index) {
      this.page.pageNumber = index;
      this.getDictionaryList(this.page);
    },
  },
};
</script>

<style lang="less">
@import '~@/styles/var.less';

.page-team {
  display: flex;
  flex: 1;
  width: 100%;
  .dialog-body {
    padding-right: 40px;
  }
}
</style>
